import React, { Component } from 'react';
import {connect} from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import { DATATABLE_CONFIG } from '../../shared/Config';

class ErrorLogs extends Component{
    state = {
    logValues:[
        {
        process:"Leave Request",
        requestNumber:"112234",
        iDocNumber:"453312",
        inboundOutbound:"Inbound",
        employeeNumber:"22134",
        employeeName:"Dinesh",
        infoType:"20001",
        subType:"106",
        beginningDate:"21/02/2020",
        enddate:"22/03/2020",
        errorMessage:"Sync Error"
        },
        ]
    }
 

    render() {

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

       
        
        
        return(
            <div className="padding">
                <div className="card card-w-title">
                <h1>Error Log</h1>
                <div className="p-col-12" >
                    <DataTable globalFilter={this.state.globalFilter} header={header} value={this.state.logValues} {...DATATABLE_CONFIG}>                                
                        <Column field="process" header="Process" />
                        <Column field="requestNumber" header="Request No" sortable={true} />
                        <Column field="iDocNumber" header="IDoc No" />
                        <Column field="inboundOutbound" header="Inbound / Outbound" />
                        <Column field="employeeNumber" header="Employee No" sortable={true} />
                        <Column field="employeeName" header="Employee Name" sortable={true} />
                        <Column field="infoType" header="Info Type" />
                        <Column field="subType" header="Sub Type" />
                        <Column field="beginningDate" header="Beginning Date" />
                        <Column field="enddate" header="End Date" />
                        <Column field="errorMessage" header="Error message" />
                    </DataTable>
                </div>
                </div>
            </div>
        )
    }
}
    






const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userPref : state.auth.userPref
    }
}
  


export default connect(mapStateToProps)(ErrorLogs)